export const SET_CONFIGURATION = 'SET_CONFIGURATION'
export const RESET_CONFIGURATION = 'RESET_CONFIGURATION'
export const RESET_TRADE_IN_CONTEXT = 'RESET_TRADE_IN_CONTEXT'

export const setConfiguration = configuration => ({
  type: SET_CONFIGURATION,
  configuration
})
export const resetConfiguration = () => ({
  type: RESET_CONFIGURATION
})
export const resetTradeInContext = () => ({
  type: RESET_TRADE_IN_CONTEXT
})
